module.exports = __webpack_public_path__ + "img/1.31f0f2c8.jpg";